import { QualityScore } from '../Quality';
import { MediaConnectionBitrateTest } from '@twilio/rtc-diagnostics';

export function getSingleQualityScore(
  stat: number | undefined,
  goodThreshold: number,
  suboptimalThreshold: number,
  poorThreshold: number,
  descending: boolean = false
) {
  if (typeof stat === 'undefined') {
    // We ignore values that are missing
    return QualityScore.Excellent;
  }

  if (descending) {
    if (stat > goodThreshold) return QualityScore.Excellent;
    if (stat > suboptimalThreshold) return QualityScore.Good;
    if (stat > poorThreshold) return QualityScore.Suboptimal;
    return QualityScore.Poor;
  }

  if (stat >= poorThreshold) return QualityScore.Poor;
  if (stat >= suboptimalThreshold) return QualityScore.Suboptimal;
  if (stat >= goodThreshold) return QualityScore.Good;
  return QualityScore.Excellent;
}

export const formatNumber = (val: number | undefined) => {
  return val?.toLocaleString(undefined, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });
};

export function getQualityScore(
  bitrateTestReportUDP: MediaConnectionBitrateTest.Report | null,
  bitrateTestReportTCP: MediaConnectionBitrateTest.Report | null
) {
  const maxBitrateUDP = bitrateTestReportUDP?.values ? Math.max(...bitrateTestReportUDP.values) : 0;
  const maxBitrateTCP = bitrateTestReportTCP?.values ? Math.max(...bitrateTestReportTCP.values) : 0;

  const bitrateUDP = {
    average: formatNumber(bitrateTestReportUDP?.averageBitrate!),
    max: formatNumber(maxBitrateUDP),
    qualityScore: getSingleQualityScore(bitrateTestReportUDP?.averageBitrate!, 1000, 500, 150, true),
  };

  const bitrateTCP = {
    average: formatNumber(bitrateTestReportTCP?.averageBitrate!),
    max: formatNumber(maxBitrateTCP),
    qualityScore: getSingleQualityScore(bitrateTestReportTCP?.averageBitrate!, 1000, 500, 150, true),
  };

  const totalQualityScore = Math.min(bitrateUDP.qualityScore, bitrateTCP.qualityScore) as QualityScore;

  return {
    bitrateUDP,
    bitrateTCP,
    totalQualityScore,
  };
}
